import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Records an image view via the dedicated backend controller: it writes a
 * VIEW_IMAGE activity-log row AND atomically increments the image's total
 * viewCount, returning `{ ok, viewCount, activityLog: { id, createdAt, sk } }` —
 * the activityLog handle lets the caller stamp `endedAt` later via
 * patchEndActivityLog. The backend resolves the project/business and image name
 * server-side, so only the ids are sent.
 */
export const postImageView = async ({
  projectId,
  filePermissionId,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const apiPath = `activity-log/project/${projectId}/image/${filePermissionId}`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {},
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
